module.exports = __webpack_public_path__ + "static/media/maple-frame-custom-mat-rendering.06d0b11d.jpg";